import { Button } from '@components/atoms/Button';
import { Card } from '@components/atoms/Card';
import TransferWithinAStationOutlinedIcon from '@mui/icons-material/TransferWithinAStationOutlined';
import TungstenOutlinedIcon from '@mui/icons-material/TungstenOutlined';

export const ButtonsGroup = () => {
  return (
    <Card>
      <div className="flex flex-col gap-4">
        <h2 className="text-lg font-bold text-gray-900 dark:text-white">
          Buttons
        </h2>
        <div className="flex flex-col">
          <Button>Click me</Button>
        </div>

        <div className="flex flex-col gap-3">
          <h2 className="text-md font-semibold text-gray-800 dark:text-gray-200">
            md
          </h2>
          <div className="flex grid-cols-4 gap-2">
            <Button
              fullWidth
              size="md"
              variant="primary"
              leftIcon={
                <TransferWithinAStationOutlinedIcon fontSize="small" />
              }>
              Click me
            </Button>
            <Button
              fullWidth
              size="md"
              variant="secondary"
              rightIcon={
                <TransferWithinAStationOutlinedIcon fontSize="small" />
              }>
              Click me
            </Button>
            <Button size="md" fullWidth variant="secondary">
              Click me
            </Button>
            <Button size="md" fullWidth variant="tertiary">
              Click me
            </Button>
            <Button
              onlyIcon
              fullWidth
              variant="tertiary"
              rightIcon={<TungstenOutlinedIcon fontSize="small" />}
            />
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <h2 className="text-md font-semibold text-gray-800 dark:text-gray-200">
            lg
          </h2>
          <div className="flex grid-cols-4 gap-2">
            <Button
              fullWidth
              size="lg"
              variant="primary"
              leftIcon={
                <TransferWithinAStationOutlinedIcon fontSize="small" />
              }>
              Click me
            </Button>
            <Button
              fullWidth
              size="lg"
              variant="secondary"
              rightIcon={
                <TransferWithinAStationOutlinedIcon fontSize="small" />
              }>
              Click me
            </Button>
            <Button size="lg" fullWidth variant="secondary">
              Click me
            </Button>
            <Button size="lg" fullWidth variant="tertiary">
              Click me
            </Button>
            <Button
              fullWidth
              size="lg"
              onlyIcon
              rightIcon={<TungstenOutlinedIcon fontSize="small" />}
            />
          </div>
        </div>
      </div>
    </Card>
  );
};
